// extracted by mini-css-extract-plugin
export var centerText = "_8d-8";
export var container = "_8d-0";
export var doughnutContainer = "_8d-7";
export var legend = "_8d-a";
export var legendItemColorDisplay = "_8d-b";
export var legendItemLabel = "_8d-d";
export var legendItemValue = "_8d-c";
export var lg = "_8d-5";
export var maxWidth = "_8d-9";
export var md = "_8d-4";
export var responsive = "_8d-6";
export var sm = "_8d-3";
export var xs = "_8d-2";
export var xxs = "_8d-1";